// Delegated listeners also work when Shopify replaces sections in the editor.
document.addEventListener('click', (event) => {
  const option = event.target.closest('.hs-guide-option');
  if (!option) return;
  const guide = option.closest('[data-hs-guide]');
  const wasOpen = option.getAttribute('aria-expanded') === 'true';
  guide.querySelectorAll('.hs-guide-option').forEach(button => button.setAttribute('aria-expanded', 'false'));
  guide.querySelectorAll('.hs-guide-result').forEach(panel => { panel.hidden = true; });
  if (!wasOpen) {
    option.setAttribute('aria-expanded', 'true');
    const panel = document.getElementById(option.getAttribute('aria-controls'));
    if (panel) panel.hidden = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.hs-mobile-menu[open],.hs-subnav[open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('shopify:block:select', (event) => {
  const option = event.target.matches?.('.hs-guide-option') ? event.target : event.target.querySelector?.('.hs-guide-option');
  if (option && option.getAttribute('aria-expanded') !== 'true') option.click();
  if (event.target.matches?.('.hs-accordion')) event.target.open = true;
  const panel = event.target.closest?.('.hs-chapter-panel');
  if (panel) document.getElementById(panel.getAttribute('aria-labelledby'))?.click();
});
document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-hs-tab]');
  if (!tab) return;
  const section = tab.closest('[data-hs-chapters]');
  section.querySelectorAll('[data-hs-tab]').forEach(button => {
    const active = button === tab;
    button.setAttribute('aria-selected', String(active));
    button.tabIndex = active ? 0 : -1;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (panel) panel.hidden = !active;
  });
});
document.addEventListener('keydown', (event) => {
  const tab = event.target.closest('[data-hs-tab]');
  if (!tab || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
  const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-hs-tab]')];
  const i = tabs.indexOf(tab);
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
  event.preventDefault(); tabs[next].focus(); tabs[next].click();
});
